// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__2FqoK","consentsList":"PatientConsents_consentsList__110N3","consentsListEmpty":"PatientConsents_consentsListEmpty__1Xsq5"};